import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { validateLoginForm } from '../utils/validation';
import { Sparkles } from 'lucide-react';
export function LoginPage() {
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoginError('');
    const validation = validateLoginForm(email, password);
    if (!validation.isValid) {
      setErrors(validation.errors);
      return;
    }
    setErrors({});
    setIsLoading(true);
    const result = await login(email, password);
    if (!result.success) {
      setLoginError(result.error || 'Error al iniciar sesión');
    }
    setIsLoading(false);
  };
  return <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-sky-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex" data-id="element-1797">
      {/* Left side - Image panel */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden" data-id="element-1798">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-500/90 to-cyan-600/90 dark:from-teal-900/80 dark:to-cyan-900/80 z-10" data-id="element-1799"></div>
        <img src="https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1200&auto=format&fit=crop" alt="Spa wellness" className="absolute inset-0 w-full h-full object-cover" data-id="element-1800" />
        <div className="relative z-20 flex flex-col justify-center items-center text-white p-12" data-id="element-1801">
          <Sparkles className="w-16 h-16 mb-6 opacity-90" data-id="element-1802" />
          <h2 className="text-4xl font-bold mb-4 text-center" data-id="element-1803">
            Bienestar y Belleza
          </h2>
          <p className="text-xl text-center text-white/90 max-w-md leading-relaxed" data-id="element-1804">
            Sistema profesional de gestión para centros de masajes, faciales y
            tratamientos de belleza
          </p>
          <div className="mt-12 grid grid-cols-3 gap-4 w-full max-w-md" data-id="element-1805">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center" data-id="element-1806">
              <p className="text-3xl font-bold" data-id="element-1807">500+</p>
              <p className="text-sm text-white/80 mt-1" data-id="element-1808">Clientes</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center" data-id="element-1809">
              <p className="text-3xl font-bold" data-id="element-1810">50+</p>
              <p className="text-sm text-white/80 mt-1" data-id="element-1811">Tratamientos</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center" data-id="element-1812">
              <p className="text-3xl font-bold" data-id="element-1813">98%</p>
              <p className="text-sm text-white/80 mt-1" data-id="element-1814">Satisfacción</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8" data-id="element-1815">
        <div className="w-full max-w-md" data-id="element-1816">
          {/* Logo and Title */}
          <div className="text-center mb-8" data-id="element-1817">
            <img src="https://cdn.magicpatterns.com/uploads/a741bfNsYBMGGZNxniTt4s/images.jpg" alt="Savidna Logo" className="w-24 h-24 mx-auto rounded-full shadow-xl mb-6 ring-4 ring-teal-100 dark:ring-teal-900" data-id="element-1818" />
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-1819">
              Savidna
            </h1>
            <p className="text-teal-600 dark:text-teal-400 font-medium text-lg" data-id="element-1820">
              Centro de Bienestar y Belleza
            </p>
          </div>

          {/* Login Form */}
          <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 border border-gray-100 dark:border-gray-700" data-id="element-1821">
            <div className="mb-8" data-id="element-1822">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-1823">
                Iniciar Sesión
              </h2>
              <p className="text-gray-600 dark:text-gray-400" data-id="element-1824">
                Ingresa tus credenciales para acceder
              </p>
            </div>

            {loginError && <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl text-red-600 dark:text-red-400 text-sm" data-id="element-1825">
                {loginError}
              </div>}

            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1826">
              <Input type="email" label="Correo Electrónico" placeholder="correo@ejemplo.com" value={email} onChange={e => setEmail(e.target.value)} error={errors.email} data-id="element-1827" />

              <Input type="password" label="Contraseña" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} error={errors.password} data-id="element-1828" />

              <Button type="submit" className="w-full mt-6" isLoading={isLoading} data-id="element-1829">
                Iniciar Sesión
              </Button>
            </form>
          </div>

          {/* Footer */}
          <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-8" data-id="element-1830">
            © 2024 Savidna. Sistema de gestión profesional para centros de
            bienestar.
          </p>
        </div>
      </div>
    </div>;
}